import styled, { css } from 'styled-components'
import { MEDIA } from 'utils/constants'
import { Card, Checkbox } from 'components/forms'

import { assetPrefix } from 'config/env_config'

// Media query
const { DESKTOP_UP, MOBILE } = MEDIA

export const ServiceCard = styled(Card)`
  margin-bottom: 0;
  height: auto;

  @media screen and (max-width: 1200px) {
    max-width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
  }

  @media screen and ${DESKTOP_UP} {
    width: 152px;
    min-height: 186px;
    padding: 16px 16px 27px;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      height: 100%;
    }
  }
`

export const Pet = styled(Card)`
  width: 116.67px;
  height: 145px;
  text-align: center;
  align-items: center;
  background: ${props => props.selected ? 'var(--Color-Primary-color-primary-50, #D8EEF6)' : 'var(--Color-Neutral-Basic-color-neutral-white, #FFF)'};
  padding: 16px;
  border-radius: 24px;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 83px;
  }

   @media screen and (max-width: 390px) {
    width: 108.67px;
  }

   @media screen and (max-width: 375px) {
    width: 103.67px;
  }
`

export const WrapperPetPhoto = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: center;
`

export const Container = styled.div`
  ${({ gap }) => css`
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: 100%;
    gap: ${gap || 0};

    @media screen and (max-width: 1200px) {
      width: unset;
      gap: 16px;
    }
  `}
`

export const Photo = styled.div`
  ${({ size, src, setDefaultPhoto, mobileSize }) => css`
    width: ${size || '40px'};
    height: ${size || '40px'};
    border-radius: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-image: url("${src}");
    background-size: ${setDefaultPhoto ? 'contain' : 'cover'};
    background-repeat: no-repeat;
    background-position: center center;
    ${({ borderRadiusNone }) => borderRadiusNone && css`
      border-radius: 0;
    `}
    @media screen and (max-width: 1200px) {
      width: ${mobileSize || '40px'};
      height: ${mobileSize || '40px'};
      min-width: ${mobileSize || '40px'};
    }

  `}
`
export const Option = styled.div`
  right: 16px;
`
export const ServiceOption = styled(Option)`
  @media screen and ${DESKTOP_UP} {
    right: calc(50% - 20px);
    bottom: 24px;
  }
`

export const AllAdditionalCheckboxContainer = styled.div`
  ${Checkbox} {
    input:checked ~ label::before {
      background: var(--cobasi-blue-light-8);
    }
  }

  div {
    margin-top: 16px;
    label {
      color: var(--gray-5);
      font-family: var(--primary-font);
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 145%;
    }
  }
`

export const CheckList = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--Spacing-Spacing-spacing-xxs, 16px);
  align-self: stretch;
  margin: 24px 0px;
  overflow-x: auto;
`

export const AdditionalServices = styled(Card)`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
  padding: 16px;
  width: 102px;
  height: 104px;
  background: ${props => props.isChecked ? 'var(--Color-Primary-color-primary-50, #D8EEF6)' : 'var(--Color-Neutral-Basic-color-neutral-white, #FFF)'};

  label{
    color: var(--Gray-gray-700, var(--Color-Neutral-Gray-color-gray-700, #555));
    text-align: center;
    font-family: 'Montserrat';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const TextareaContainer = styled.div`
  position: relative;
  label {
    position: absolute;
    top: 34px;
    left: 14px;
    background-color: var(--the-white);
    color: var(--gray-5);
    font-family: var(--primary-font);
    font-size: 16px;
    line-height: 19.07px;
    padding: 4px;
    z-index: 1;
  }

  scroll-margin-top: 88px;

  @media screen and ${DESKTOP_UP} {
    max-width: 704px;
    width: 100%;
  }

  @media screen and (max-width: 1200px) {
    max-width: 100%;
    width: 100%;
  }

  @media screen and ${MOBILE} {
    :focus-within {
      padding-top: 8px;
      label {
        margin-top: 8px;
      }
    }
  }
`

export const ObsTextArea = styled.textarea`
  resize: none;
  width: 100%;
  min-height: 76px;
  padding: 16px;
  color: var(--gray-5);
  font-family: var(--primary-font);
  font-size: 16px;
  font-weight: 400;
  line-height: 21.79px;
  border-color: var(--dim-gray);
  margin-top: 32px;
  border-radius: 16px;
  ::placeholder {
    color: var(--gray-7);
    max-height: 108px;
  }
`

export const Counter = styled.div`
  text-align: end;
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 400;
  color: var(--gray-7);
  margin-top: -4px;
  margin-right: 16px;
  line-height: normal;
`

export const TextInfo = styled.div`
  ${({ isService }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;

    span:first-of-type {
      font-size: 16px;
      font-weight: 600;
      line-height: 19.2px;
      font-family: var(--primary-font);
    }

    span:last-of-type {
      font-size: 13px;
      font-weight: 400;
      line-height: 17.7px;
      font-family: var(--primary-font);
    }

    ${isService && css`
      span:last-of-type {
        font-size: 16px;
        font-weight: 600;
        line-height: 16.8px;

        text-align: center;
        margin: 16px 0 24px 0;

        @media screen and (max-width: 1200px) {
          margin: unset;
          text-align: start;
        }
      }
    `}
  `}
`

export const PageContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: 1200px) {
    padding: 0 16px;
  }
`

export const AlignWrappers = styled.div`
  flex: 1;
  max-width: 1040px;
  margin-bottom: 24px;

  ${({ noMargin }) => noMargin && css`
    margin-bottom: 0;
  `}
`

export const WrapperForm = styled(AlignWrappers)`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  ${({ noMargin }) => noMargin && css`
    margin-bottom: 0;
  `}
`

export const NoPetData = styled.div`
  border: 1px solid var(--silver);
  padding: 16px;
  border-radius: 2.4rem;
  max-width: 754px;
`

export const WrapperElements = styled.div`
  display: flex;
  margin-top: 24px;
  max-width: 754px;
  width: 100%;
  gap: 16px;
  flex-wrap: wrap;
  position: relative;
`

export const WrapperServices = styled.div`
  display: flex;
  max-width: 752px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 24px;
  position: relative;
`

export const WrapperAdditionalServices = styled.div`
  display: flex;
  flex-direction: column;
`

export const PetRegistration = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 10px;
  height: 40px;
  font-size: 16px;
  line-height: normal;
  font-weight: 600;
  font-family: var(--primary-font);
  color: var(--cobasi-blue-light-9);

  :before {
    content: url('${assetPrefix}/static/icons/plus.svg');
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 8px;
  }

  :active {
    transition: 0.1s;
    opacity: 0.3;
  }

  :hover {
    transition: 0.3s;
    opacity: 0.8;
  }

  cursor: pointer;
`

export const WrapperAdditionalServicesAndObs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const UseExistingPet = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 16px;
  flex: 1 0 0;
  color: var(--Gray-gray-900, var(--Color-Neutral-Gray-color-gray-900, #222));
  font-family: 'Montserrat';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`
export const PetNotFound = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--Spacing-Spacing-spacing-xxs, 16px);
  flex: 1 0 0;
`

export const PetNotFoundTitle = styled.div`
  color: var(--Color-Neutral-Gray-color-gray-900, #222);
  text-align: center;
  font-family: 'Montserrat';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`

export const PetNotFoundTextInfo = styled.div`
  color: var(--Color-Neutral-Gray-color-gray-700, #555);
  text-align: center;
  font-family: 'Montserrat';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-self: stretch;
`

export const WrapperTitle = styled.div`
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;

  ${({ firstContainer }) => firstContainer && css`
    @media screen and (max-width: 1200px) {
      margin-top: 28px;
    }
  `}

  ${({ isServices }) => isServices && css`
    font-size: 16px;
    line-height: 19.2px;
  `}

  ${({ isPet }) => isPet && css`
    margin-bottom: 24px;
  `}
`

export const SliderContainer = styled.div`
  width: 100%;
  .slick-dots {
    position: relative;
    bottom: 0;
    margin-top: 24px;

    li {
      width: 0px;
      height: 0px;
      margin: 0 10px;
    }

    li.slick-active button {
      max-width: 12px;
      max-height: 12px;
      border-radius: 50px;
      background: var(--Color-Primary-color-primary-800, #028BB7);
    }

    li button {
      max-width: 8px;
      max-height: 8px;
      border-radius: 50px;
      background: var(--Color-Neutral-Gray-color-gray-300, #DADADA);
      padding: 0px;
    }

    li button:before,
    li.slick-active button:before {
      color: unset !important;
    }
  }
`
